import ContactsBaseDetailsPageController from './base';

export default class ContactsDetailsCheckInsPageController extends ContactsBaseDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/controllers/pages/details/checkins.js